import { CarrierUpdateForm } from 'components/Pages/Carriers';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const CarrierUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/transportadoras');
  }, [navigate]);

  return (
    <Scaffold>
      <CarrierUpdateForm carrierId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
